// oxlint-disable-next-line no-restricted-imports
import { Redirect, useLocalSearchParams, usePathname } from 'expo-router'
import type { ReactNode } from 'react'

const proxyRedirect = {
  singleIntention: {
    source: /^\/(fr\/intention|en\/intention|es\/intencion|pt\/intencao)\/(.*)$/,
    destination: '/intention',
  },
  intentions: {
    source: /^\/(fr\/intentions|en\/intentions|es\/intenciones|pt\/intencoes)\/?(.*)$/,
    destination: '/intentions',
  },
  publication: {
    source: /^\/(fr\/publication|en\/publication|es\/publicacion|pt\/publicacao)\/?(.*)$/,
    destination: '/publication',
  },
  community: {
    source: /^\/(fr\/communaute|en\/community|es\/comunidad|pt\/comunidade)\/?(.*)$/,
    destination: '/community',
  },
}

type TLegacyProxyRedirectProps = {
  proxyRedirectKey: keyof typeof proxyRedirect
}

export const LegacyProxyRedirect = ({ proxyRedirectKey }: TLegacyProxyRedirectProps): ReactNode => {
  const pathname = usePathname()
  const params = useLocalSearchParams()

  const redirectUrl = () => {
    let redirectURL = ''
    const rule = proxyRedirect[proxyRedirectKey]
    const regex = rule.source
    const match = pathname.match(regex)
    if (match) {
      const [, , pathParams] = match
      const { 'not-found': _, ...queryParamsObj } = params
      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObj).map(([key, value]) => [key, Array.isArray(value) ? value.join(',') : value]),
      ).toString()
      redirectURL = rule.destination + (pathParams ? '/' + pathParams : '') + (queryParams ? '?' + queryParams : '')
    }
    return redirectURL ?? '/intention'
  }

  const redirectURL = redirectUrl()

  return <Redirect href={redirectURL || '/'} />
}
